import { OptionProps } from 'components/Common/Form/Select';

export enum Types {
	ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE = '@SGU/ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE',
	ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_SUCCESS = '@SGU/ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_SUCCESS',
	ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_FAILURE = '@SGU/ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_FAILURE',
	ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE_CLEAR = '@SGU/ATUALIZAR_PARAMETRO_LOCALIDADE_DETALHE__CLEAR',
}

export interface AtualizarParametroLocalidadeDetalhe {
	status: number;
	data: LocalidadesAssociada[] | null;
	enum: OptionProps[];
	totalRegistrosConsulta: number;
}

export interface ParametroLocalidade {
	siglaParametro: string;
	descricaoParametro: string;
	localidades: LocalidadesAssociada[] | [];
}

export interface AtualizarParametroLocalidadeDetalheRequest {
	descricao: string;
	sigla: string;
	valor: string;
	idLocalidade: number[];
}

export interface LocalidadesAssociada {
	idLocalidade: number | string;
	nomeLocalidade: string;
	idParametro: number | string;
	valorParametro: string;
	key: string;
}
